import TableCellLabels from "ds/components/Table/Row/CellLabels";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { PluginTemplate } from "types/generated";

const PluginTemplatesTableLabelsCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<PluginTemplate>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels tags={template.labels} />
    </TableSimpleCell>
  );
};

export default PluginTemplatesTableLabelsCell;
